export enum FareScope {
    TimeLimited = 'timeframe',
    EntireBooking = 'booking',
    OnlyThisTime = 'once',
    Definitive = 'definitive'
}
